import { MENU_STATES } from './actionTypes';
import { MenuStateAction, DispatchType } from './../types';

export function SetMenuState(menuState: boolean) {
  const action: MenuStateAction = {
    type: MENU_STATES,
    menuState,
  };
  return handleDispatch(action);
}

export function handleDispatch(action: MenuStateAction) {
  return (dispatch: DispatchType) => {
    dispatch(action);
  };
}
